/**
 * Resolves `redirectUrl` on magic-link entry URLs to a post-auth destination:
 * - Relative aliases → internal app paths (e.g. `courses` → `/courses`)
 * - `https://` URLs → passed through for external redirect after auth
 */

const REDIRECT_URL_ALIAS_TO_PATH: Record<string, string> = {
  affiliate: '/affiliates',
  courses: '/courses',
  communities: '/communities',
}

export function resolveMagicLinkRedirectUrlParam(value: string | undefined): string | null {
  if (value == null) return null

  const trimmed = value.trim()
  if (!trimmed) return null

  const lower = trimmed.toLowerCase()

  if (lower.startsWith('https://')) {
    try {
      const parsed = new URL(trimmed)
      return parsed.protocol === 'https:' && parsed.hostname ? trimmed : null
    } catch {
      return null
    }
  }

  if (lower.startsWith('//') || lower.includes('://')) return null

  if (lower.startsWith('/')) return trimmed

  return REDIRECT_URL_ALIAS_TO_PATH[lower.split('/')[0]] ?? null
}
